// Frontend hace switch por `code`, NO por `title` ni `status` (P5 §5.2).
export const ErrorCode = {
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    OA_NOT_ASSIGNED_TO_MILESTONE: 'OA_NOT_ASSIGNED_TO_MILESTONE',
    LEARNER_HAS_ACTIVE_SESSION: 'LEARNER_HAS_ACTIVE_SESSION',
    LEARNER_PROXY_ONLY: 'LEARNER_PROXY_ONLY',
    MODALITY_INVALID_FOR_LEVEL: 'MODALITY_INVALID_FOR_LEVEL',
    PROXY_NOT_AUTHORIZED_FOR_LEARNER: 'PROXY_NOT_AUTHORIZED_FOR_LEARNER',
    SESSION_NOT_FOUND: 'SESSION_NOT_FOUND',
    SESSION_NOT_CLOSED: 'SESSION_NOT_CLOSED',
    SESSION_NOT_OWNED: 'SESSION_NOT_OWNED',
    /** Handler recibió request de escritura sobre sesión en estado terminal (CT-H1). */
    SESSION_ALREADY_CLOSED: 'SESSION_ALREADY_CLOSED',
    AD_TOKEN_INVALID_SIGNATURE: 'AD_TOKEN_INVALID_SIGNATURE',
    AD_TOKEN_EXPIRED: 'AD_TOKEN_EXPIRED',
    AD_TOKEN_WRONG_AUDIENCE: 'AD_TOKEN_WRONG_AUDIENCE',
    AD_TOKEN_WRONG_TENANT: 'AD_TOKEN_WRONG_TENANT',
    AD_TOKEN_MISSING_SCOPE: 'AD_TOKEN_MISSING_SCOPE',
    AD_TOKEN_MISSING_EMAIL_CLAIM: 'AD_TOKEN_MISSING_EMAIL_CLAIM',
    WS_TOKEN_EXPIRED_BEYOND_GRACE: 'WS_TOKEN_EXPIRED_BEYOND_GRACE',
    PIONEROS_USER_NOT_FOUND: 'PIONEROS_USER_NOT_FOUND',
    NO_ACCESSIBLE_SITES: 'NO_ACCESSIBLE_SITES',
    SITE_REQUIRED: 'SITE_REQUIRED',
    SITE_MISMATCH: 'SITE_MISMATCH',
    ROLE_NOT_AUTHORIZED: 'ROLE_NOT_AUTHORIZED',
    KILL_SWITCH_ACTIVE: 'KILL_SWITCH_ACTIVE',
    IDEMPOTENCY_KEY_REUSED_WITH_DIFFERENT_BODY: 'IDEMPOTENCY_KEY_REUSED_WITH_DIFFERENT_BODY',
    IDEMPOTENT_REQUEST_IN_FLIGHT: 'IDEMPOTENT_REQUEST_IN_FLIGHT',
    VERSION_CONFLICT: 'VERSION_CONFLICT',
    LEVEL_MINEDUC_UNRECOGNIZED: 'LEVEL_MINEDUC_UNRECOGNIZED',
    RATE_LIMITED: 'RATE_LIMITED',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    RBAC_RULE_MISSING: 'RBAC_RULE_MISSING',
    PIONEROS_UNAVAILABLE: 'PIONEROS_UNAVAILABLE',
    ENRICHMENT_WARMING: 'ENRICHMENT_WARMING',
    IDENTITY_PROVIDER_UNAVAILABLE: 'IDENTITY_PROVIDER_UNAVAILABLE',
    /** Link mágico (invite alumno) — firma inválida o payload corrupto. */
    LINK_TOKEN_INVALID: 'LINK_TOKEN_INVALID',
    /** Link mágico vencido (invite_expires_at pasado o `exp` del JWT). */
    LINK_TOKEN_EXPIRED: 'LINK_TOKEN_EXPIRED',
    /** Link mágico revocado (profe cerró el aula o regeneró el invite). */
    LINK_TOKEN_REVOKED: 'LINK_TOKEN_REVOKED',
};
// Reintento con misma Idempotency-Key re-ejecuta el handler (P5 §6.2) — no se cachea.
export const RETRIABLE_ERROR_CODES = new Set([
    ErrorCode.PIONEROS_UNAVAILABLE,
    ErrorCode.ENRICHMENT_WARMING,
    ErrorCode.IDENTITY_PROVIDER_UNAVAILABLE,
    ErrorCode.INTERNAL_ERROR,
]);
export const ERROR_HTTP_STATUS = {
    VALIDATION_ERROR: 400,
    OA_NOT_ASSIGNED_TO_MILESTONE: 400,
    LEARNER_HAS_ACTIVE_SESSION: 400,
    LEARNER_PROXY_ONLY: 403,
    MODALITY_INVALID_FOR_LEVEL: 400,
    PROXY_NOT_AUTHORIZED_FOR_LEARNER: 403,
    SESSION_NOT_FOUND: 404,
    SESSION_NOT_CLOSED: 409,
    SESSION_NOT_OWNED: 403,
    SESSION_ALREADY_CLOSED: 409,
    AD_TOKEN_INVALID_SIGNATURE: 401,
    AD_TOKEN_EXPIRED: 401,
    AD_TOKEN_WRONG_AUDIENCE: 401,
    AD_TOKEN_WRONG_TENANT: 401,
    AD_TOKEN_MISSING_SCOPE: 401,
    AD_TOKEN_MISSING_EMAIL_CLAIM: 401,
    WS_TOKEN_EXPIRED_BEYOND_GRACE: 401,
    PIONEROS_USER_NOT_FOUND: 403,
    NO_ACCESSIBLE_SITES: 403,
    SITE_REQUIRED: 400,
    SITE_MISMATCH: 403,
    ROLE_NOT_AUTHORIZED: 403,
    KILL_SWITCH_ACTIVE: 503,
    IDEMPOTENCY_KEY_REUSED_WITH_DIFFERENT_BODY: 409,
    IDEMPOTENT_REQUEST_IN_FLIGHT: 409,
    VERSION_CONFLICT: 409,
    LEVEL_MINEDUC_UNRECOGNIZED: 422,
    RATE_LIMITED: 429,
    INTERNAL_ERROR: 500,
    RBAC_RULE_MISSING: 500,
    PIONEROS_UNAVAILABLE: 503,
    ENRICHMENT_WARMING: 503,
    IDENTITY_PROVIDER_UNAVAILABLE: 503,
    LINK_TOKEN_INVALID: 401,
    LINK_TOKEN_EXPIRED: 401,
    LINK_TOKEN_REVOKED: 403,
};
//# sourceMappingURL=codes.js.map